interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  {
    name: 'tinggcheckout',
    src: 'https://developer.tingg.africa/checkout/v2/tingg-checkout.js',
  },
  // {name: 'rangeSlider', src: '../../../assets/js/ion.rangeSlider.min.js'}
];
